<!--eslint-disable-->
<template >
  <div class="groupBooking f16">
    <div class="lin_15 f16 gray_3 fb">
      拼团策略 - 添加拼团
    </div>
    <div class="box20"></div>
    <div class=" t_right">
      <span class="group_btn b_red white f16 t_center" @click="toGroupList">返回活动列表</span>
    </div>
    <div class="box20"></div>
    <div>
      <p class="ps_main_head">温馨提示：最终的价格，以商品列表计算后展示的价格为准</p>
      <el-form ref="form" :model="activity" :rules="rules" label-width="160px">
        <el-form-item label="拼团活动名称" prop="title">
          <el-input v-model="activity.title" maxlength="35"></el-input>
        </el-form-item>
        <el-form-item label="活动时间">
          <el-date-picker
            v-model="activity.date"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
            :picker-options="pickerOptions">
          </el-date-picker>
          <span class="pad30_l red f12">提示：活动结束，活动商品自动转为原价</span>
        </el-form-item>
<!--        <el-form-item label="公开展示">
          <el-radio-group v-model="activity.isPublic">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
          <span class="pad30_l red f12">提示：若信息非公开展示，则会在列表页生成专属活动链接</span>
        </el-form-item>-->
        <el-form-item label="拼团类型">
          <el-radio-group v-model="activity.groupType" class="groupType">
            <el-radio :label="1" border>促活团
              <p class="pad10_t">该团适用于店铺促活，全部用户</p>
              <p>均可参与</p>
            </el-radio>
            <el-radio :label="2" border>拉新团
              <p class="pad10_t">该团使用店铺拉新，仅限新用户</p>
              <p>(仅在商城下单的用户)参与</p>
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动商品">
          <span class="group_btn b_red white f14 t_center" @click="selectGoodsList" >点击添加商品</span>
        </el-form-item>
        <el-table
          v-if="checkGoodsList.length"
          ref="multipleTable"
          :data="checkGoodsList"
          tooltip-effect="dark"
          style="width: 100%"
          class="mar20_b"
          @selection-change="handleSelectionChange">
<!--          <el-table-column
            type="selection"
            width="70">
          </el-table-column>-->
          <el-table-column
            prop="name"
            label="货品名称"
            width="180">
          </el-table-column>
          <el-table-column
            prop="spec"
            label="规格"
            width="80">
          </el-table-column>
          <el-table-column
            prop="marketPriceStr"
            label="原价(元)"
            width="90">
          </el-table-column>
          <el-table-column
            label="拼团价"
            width="100">
            <template #default="scope">
              <el-input v-model="scope.row.goodsPrice" @blur="scope.row.goodsPrice=formatNums(scope.row.goodsPrice,true)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="团长价"
            width="100">
            <template #default="scope">
              <el-input v-model="scope.row.sponsorPrice" @blur="scope.row.sponsorPrice=formatNums(scope.row.sponsorPrice,true)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="成团人数"
            width="110">
            <template #default="scope">
              <el-input v-model="scope.row.peopleLimit" @blur="scope.row.peopleLimit=formatNums(scope.row.peopleLimit,false)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="活动商品数"
            width="100">
            <template #default="scope">
              <el-input v-model="scope.row.goodsQuantity" @blur="scope.row.goodsQuantity=formatNums(scope.row.goodsQuantity,true)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="限制开团次数"
            width="120">
            <template #default="scope">
              <el-input v-model="scope.row.volumeLimit" @blur="scope.row.volumeLimit=formatNums(scope.row.volumeLimit,false)"></el-input>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template #default="scope">
              <span class="red cursor" @click="deleteRow(scope.$index, checkGoodsList)">删除</span>
            </template>
          </el-table-column>
        </el-table>
        <el-form-item label="是否设置团长福利">
          <el-radio-group v-model="activity.activityDtl.sponsorRewardType">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">优惠券</el-radio>
<!--            <el-radio :label="2">商品</el-radio>-->
          </el-radio-group>
          <span class="pad30_l red f12" v-if="activity.activityDtl.sponsorRewardType === 2">提示：拼团成功后，默认为团长生成一笔当前商品0元的订单，请及时发货</span>
          <div v-if="activity.activityDtl.sponsorRewardType === 1">
            <span class="group_btn b_red white f14 t_center" @click="chooseCoupon(checkCouponList, false)">点击选择优惠券</span>
            <div class="mar20_t coupon_list">
              <ul class="clear f12 white">
                <li v-for="(coupon,index) in checkCouponList" v-bind:key="coupon.regCode">
                  <div class="coupon_delete" @click="removeCheckCoupon(index, checkCouponList)">
                    <i class="iconfont icon-iconfontshibai red f15"></i>
                  </div>
                  <div class="clear coupon_price">
                    <span class="float-left f24 lin_30">{{coupon.regVal}}</span>
                    <div class="float-right t_right">
                      <p>满{{coupon.regKey}}元可用</p>
                      <p v-if="coupon.busType === 'SHOP'">全部货品可用</p>
                      <p v-if="coupon.busType === 'GOODS'">指定货品可用</p>
                      <p v-if="coupon.busType === 'CATE'">指定分类可用</p>
                    </div>
                  </div>
                  <p class="t_center">领取时间：{{coupon.startTimeStr}}至{{coupon.endTimeStr}}</p>
                  <p class="t_center">使用时间：{{coupon.useStartTimeStr}}至{{coupon.useEndTimeStr}}</p>
                  <div class="clear coupon_num gray_3">
                    <p class="float-left">数量：<em class="red">{{coupon.surplusNum}}</em></p>
                    <p class="float-right" v-if="coupon.residueEndDay">即将到期</p>
                    <!--<span class="float-right" v-if="coupon.residueEndDay">即将到期</span>-->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="拼团失败补偿">
          <el-radio-group v-model="activity.activityDtl.failRewardType">
            <el-radio :label="0">无</el-radio>
            <el-radio :label="1">优惠券</el-radio>
          </el-radio-group>
          <div v-if="activity.activityDtl.failRewardType === 1">
            <span class="group_btn b_red white f14 t_center"  @click="chooseCoupon(compensationCouponList, true)">点击选择优惠券</span>
            <div class="mar20_t coupon_list">
              <ul class="clear f12 white">
                <li v-for="(coupon,index) in compensationCouponList" v-bind:key="coupon.regCode">
                  <div class="coupon_delete" @click="removeCheckCoupon(index, compensationCouponList)">
                    <i class="iconfont icon-iconfontshibai red f15"></i>
                  </div>
                  <div class="clear coupon_price">
                    <span class="float-left f24 lin_30">{{coupon.regVal}}</span>
                    <div class="float-right t_right">
                      <p>满{{coupon.regKey}}元可用</p>
                      <p v-if="coupon.busType === 'SHOP'">全部货品可用</p>
                      <p v-if="coupon.busType === 'GOODS'">指定货品可用</p>
                      <p v-if="coupon.busType === 'CATE'">指定分类可用</p>
                    </div>
                  </div>
                  <p class="t_center">领取时间：{{coupon.startTimeStr}}至{{coupon.endTimeStr}}</p>
                  <p class="t_center">使用时间：{{coupon.useStartTimeStr}}至{{coupon.useEndTimeStr}}</p>
                  <div class="clear coupon_num gray_3">
                    <p class="float-left">数量：<em class="red">{{coupon.surplusNum}}</em></p>
                    <p class="float-right" v-if="coupon.residueEndDay">即将到期</p>
                    <!--<span class="float-right" v-if="coupon.residueEndDay">即将到期</span>-->
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="分享图片">
          <!--class="avatar-uploader share_uploader"-->
          <el-upload
            class="share-uploader"
            action="https://upload-z2.qiniup.com/"
            :show-file-list="false"
            :on-success="shareSuccess"
            :before-upload="shareBeforeUpload"
            :data="postData">
            <img v-if="shareImageUrl" :src="shareImageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p class="f12 gray_9 lin_20">当前为默认图片，若需自定义，可点击图片进行更换</p>
          <p class="f12 gray_9 lin_20">文件格式jpg、png，文件大小300KB以内，建议尺寸750px*600px</p>
        </el-form-item>
        <el-form-item label="顶部宣传图">
          <el-upload
            class="top-uploader"
            action="https://upload-z2.qiniup.com/"
            :show-file-list="false"
            :on-success="topSuccess"
            :before-upload="shareBeforeUpload"
            :data="postData">
            <img v-if="topImageUrl" :src="topImageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p class="f12 gray_9 lin_20">当前为默认图片，若需自定义，可点击图片进行更换</p>
          <p class="f12 gray_9 lin_20">文件格式jpg、png，文件大小300KB以内，建议尺寸750px*600px</p>
        </el-form-item>
        <el-form-item label="活动规则">
          <Tinymce ref="tinymce" id="id"  :contentInit="contentInit"></Tinymce>
        </el-form-item>
        <el-form-item>
          <div class="t_center">
            <el-button @click="toGroupList">取消</el-button>
            <el-button type="primary" @click="onSubmit">确认</el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <!--选择商品弹框-->
    <el-dialog
      title="选择商品"
      :visible.sync="chooseGoodVisible"
      :close-on-click-modal="false"
      width="1140px"
      top="80px"
      :show-close="false"
      custom-class="chooseGoodPop">
      <div>
        <div class="clear ps_search_wrap">
          <span class="float-left pad15_r lin_30 inlineblock">货品名称</span>
          <div class="ps_search float-left">
            <el-input
              type="text"
              placeholder="请输入货品名称"
              v-model="searchGoods.name"
            >
            </el-input>
          </div>
          <div class="float-left client_pop_query" @click="listShopGoods(1)">搜索</div>
        </div>
        <div class="clear appoint_goods_list">
          <div class="float-left client_list_all">
            <p>本店货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item,index) in goodsDataList" :key="index"  @click="goodsDialogSelect(item)">
                  <img class="float-left appoint_good_img" :src="item.picUrl" alt="">
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis f14">{{item.name}}</p>
                    <p class="f12">规格：{{item.spec}}</p>
                    <p class="f12">原价：¥{{item.marketPriceStr}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="float-right client_list_me">
            <p>已选货品</p>
            <div class="client_list_wrap">
              <ul class="clear">
                <li v-for="(item,index) in goodsSelectList" :key="index">
                  <i class="iconfont icon-shibai fb" @click="removeSelectGoods(index)"></i>
                  <img class="float-left appoint_good_img" :src="item.picUrl" alt="">
                  <div class="float-left appoint_good_main">
                    <p class="ellipsis f14">{{item.name}}</p>
                    <p class="f12">规格：{{item.spec}}</p>
                    <p class="f12">原价：¥{{item.marketPriceStr}}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="box10"></div>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount">
      </el-pagination>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="goodsDialogConfirm">确 认</el-button>
        <el-button @click="chooseGoodVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <!--选择优惠券弹框-->
    <el-dialog
      title="选择优惠券"
      :visible.sync="chooseCouponVisible"
      :close-on-click-modal="false"
      width="540px"
      top="120px"
      :show-close="false"
      custom-class="chooseCouponPop">
      <div class="coupon_list">
        <ul class="clear f12 white">
          <li v-for="coupon in shopCouponList"
              v-bind:key="coupon.regCode"
              v-bind:class="{'coupon_check' : coupon.isCheck}"
              v-if="coupon.surplusNum > 0"
              @click="checkCoupon(coupon)">
            <div class="clear coupon_price">
              <span class="float-left f24">￥{{coupon.regVal}}</span>
              <span class="float-left pad5_l lin_35">满{{coupon.regKey}}</span>
            </div>
            <p class="pad20_l f14">有效期至{{coupon.endTimeStr}}</p>
            <div class="box15"></div>
            <div class="clear coupon_num gray_3">
              <span class="float-left" v-if="coupon.busType === 'SHOP'">全部货品可用</span>
              <span class="float-left" v-else-if="coupon.busType === 'GOODS'">指定货品可用</span>
              <span class="float-left" v-else-if="coupon.busType === 'CATE'">指定分类可用</span>
            </div>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmCheckCoupon">确 定</el-button>
        <el-button @click="chooseCouponVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Tinymce from "@/components/tinymce";

export default {
  components: {
    Tinymce,
  },
  data() {
    return {
      TinymceMain: "",
      contentInit: {},
      activityId: "",
      origin: process.env,
      postData: {
        token: "",
      },
      shareImageUrl: "https://cmscenter-files.nxin.com/zx/i/fenxiang.png",
      shareVisible: false,
      topImageUrl: "https://cmscenter-files.nxin.com/zx/i/dingbuxuanchuan.png",
      topImage: {},
      shareImage: {},
      topVisible: false,
      content: null,
      editorOption: {},
      activity: {
        title: "",
        isPublic: 0,
        date: "",
        groupType: 1,
        startTime: "",
        endTime: "",
        activityDtl: {
          sponsorRewardType: 0,
          failRewardType: 0,
          shareImage: "",
          coverImage: "",
        },
        activityGoodsList: [],
      },
      rules: {
        title: [{ required: true, message: "请输入活动名称", trigger: "blur" }],
        date: [
          {
            groupType: "date",
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
      },
      chooseCouponVisible: false,
      chooseGoodVisible: false,
      shopCouponList: [], // 店铺全部优惠券
      checkCouponList: [], // 团长补偿的优惠券
      compensationCouponList: [], // 成团失败补偿的优惠券
      isCompensation: false, // 是否显示成团失败补偿的优惠券弹窗
      pageSize: 10, // 商品列表页分页大小
      currentPage: 1, // 商品列表页当前分页
      totalCount: 0, // 商品列表页商品总数
      goodsDataList: [], // 店铺商品列表
      goodsSelectList: [], // 店铺商品选中列表
      checkGoodsList: [], // 选择的商品
      searchGoods: {
        name: "",
        axis: "",
        pageNum: 1,
        pageSize: 10,
        isoa: 0,
        status: "5",
        isGroup: 1,
        isVip: 0,
      },
      // 禁用选择当前时间之前
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.activityId = this.$route.query.activityId;
    this.goodsToken(); // 获取上传图片的token
    this.listShopCoupon(); // 获取优惠券
    this.listShopGoods(); // 获取商品
  },
  // 进入页面加载数据 -相当于jquery的ready
  mounted() {},
  // 监听器
  filters: {},
  methods: {
    deleteRow(index, rows) {
      rows.splice(index, 1);
    },
    // 获取优惠券
    listShopCoupon() {
      this.$store.dispatch("coupon/coupon/getShopCouponList").then((data) => {
        if (data) {
          this.shopCouponList = data;
          this.shopCouponList.forEach((coupon) => {
            this.$set(coupon, "isCheck", false);
          });
        }
        if (this.activityId) {
          this.detail();
        }
      });
    },
    // 打开优惠券弹窗
    chooseCoupon(list, state) {
      this.isCompensation = state;
      this.shopCouponList.forEach((coupon) => {
        coupon.isCheck = false;
        if (list.findIndex((c) => c.regCode === coupon.regCode) >= 0) {
          coupon.isCheck = true;
        }
      });
      this.chooseCouponVisible = true;
    },
    // 选择优惠券
    checkCoupon(coupon) {
      this.$set(coupon, "isCheck", !coupon.isCheck);
    },
    // 确定选择优惠券
    confirmCheckCoupon() {
      if (this.isCompensation) {
        this.compensationCouponList = [];
        this.shopCouponList.forEach((coupon) => {
          if (coupon.isCheck) {
            this.compensationCouponList.push(coupon);
          }
        });
      } else {
        this.checkCouponList = [];
        this.shopCouponList.forEach((coupon) => {
          if (coupon.isCheck) {
            this.checkCouponList.push(coupon);
          }
        });
      }
      this.chooseCouponVisible = false;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.listShopGoods();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.listShopGoods();
    },
    // 点击添加货品
    selectGoodsList() {
      this.listShopGoods(2);
      this.goodsSelectList = [];
      this.checkGoodsList.forEach((goods) => {
        this.goodsSelectList.push(goods);
      });
    },
    // 查询店铺全部在售非oa商品
    listShopGoods(type) {
      if (type) {
        this.currentPage = 1;
      }
      this.searchGoods.pageNum = this.currentPage;
      this.searchGoods.pageSize = this.pageSize;
      this.$store.dispatch("goods/goods/getShopGoodsList", this.searchGoods).then((data) => {
        if (data && data.goodsList) {
          // 初始化数据
          data.goodsList.forEach((goods) => {
            goods.sponsorPrice = goods.marketPriceStr; // 团长价
            goods.goodsPrice = ""; // 拼团价
            goods.peopleLimit = 2; // 成团人数
            goods.goodsQuantity = goods.currQuantity; // 活动商品数
            goods.volumeLimit = ""; // 开团次数
          });
          this.goodsDataList = data.goodsList;
          this.totalCount = data.totalCount;
        }
        if (type === 2) {
          if (this.goodsDataList.length === 0) {
            this.$message.error("无货品数据,请添加货品");
            return;
          }
          this.chooseGoodVisible = true;
        }
      });
    },
    // 商品列表页点击商品
    goodsDialogSelect(goods) {
      const index = this.goodsSelectList.findIndex((g) => goods.goodsId === g.goodsId);
      if (index < 0) {
        this.goodsSelectList.push(goods);
      }
    },
    // 删除选择商品弹框中已选择商品
    removeSelectGoods(index) {
      this.goodsSelectList.splice(index, 1);
    },
    // 确定选择商品
    goodsDialogConfirm() {
      this.checkGoodsList = [];
      this.goodsSelectList.forEach((goods) => {
        this.checkGoodsList.push(goods);
      });
      // compensationCouponList
      this.chooseGoodVisible = false;
    },
    // 删除已选中商品
    removeCheckGoods(index) {
      this.checkGoodsList.splice(index, 1);
    },
    removeCheckCoupon(index, list) {
      list.splice(index, 1);
    },
    // 获取上传文件时候的token
    goodsToken() {
      this.$store.dispatch("app/getUploadToken").then((data) => {
        this.postData.token = data;
      });
    },
    sharePreview(file) {
      this.shareVisible = true;
      this.shareImage = file.url;
    },

    shareSuccess(file) {
      console.log("上传成功", file);
      const url = `${this.origin.VUE_APP_IMGURL}${file.key}`;
      this.shareImageUrl = url;
    },
    // 上传图片之前
    shareBeforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message({
          message: "上传图片大小不能超过 2MB",
          type: "warning",
        });
      } else if (!isJPG && !isPNG) {
        this.$message({
          message: "上传图片必须是JPG/PNG 格式",
          type: "warning",
        });
      }
      return (isJPG || isPNG) && isLt2M;
    },

    shareExceed() {
      this.$message({
        message: "最多只能上传一张图片",
        type: "warning",
      });
    },
    topPreview(file) {
      console.info(file);
      this.topVisible = true;
      this.topImage = file.url;
    },
    topSuccess(file) {
      console.log("上传成功", file);
      const url = `${this.origin.VUE_APP_IMGURL}${file.key}`;
      this.topImageUrl = url;
    },
    topRemove(file, fileList) {
      console.log(file, fileList);
      this.topImageUrl = "https://cmscenter-files.nxin.com/zx/i/dingbuxuanchuan.png";
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // num 输入的数字 decimal 小数 true false
    formatNums(nums, decimal) {
      let value = `${nums}`;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp("^(-)?(\\d{1,8})\\.(\\d{0,4}).*$");
      value = value.replace(reg, "$1$2.$3");
      console.info(value);
      if (value.indexOf(".") < 0 && value !== "" && value !== "-") {
        // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }
      if (value && !decimal) {
        value = parseInt(value, 10);
      }
      if (value === 0) {
        return "";
      }
      return value;
    },
    // 保存
    onSubmit() {
      const { activity } = this;
      // 校验参数
      if (!activity.title) {
        this.$message.error("名称不能为空");
        return;
      }
      if (!activity.date || activity.date.length <= 0) {
        this.$message.error("时间不能为空");
        return;
      }
      // 商品
      if (this.checkGoodsList.length <= 0) {
        this.$message.error("请选择商品");
        return;
      }
      for (const goods of this.checkGoodsList) {
        if (!goods.sponsorPrice || !goods.goodsPrice) {
          this.$message.error("请输入活动商品价格");
          return;
        }
        if (!goods.peopleLimit || parseFloat(goods.peopleLimit) <= 1) {
          this.$message.error("成团人数至少两人以上");
          return;
        }
        if (!goods.goodsQuantity) {
          this.$message.error("请输入活动商品数");
          return;
        }
        // 库存校验
        if (parseFloat(goods.goodsQuantity) > parseFloat(goods.currQuantity)) {
          this.$message.error("库存不足");
          return;
        }
        if (parseFloat(goods.sponsorPrice) > parseFloat(goods.marketPriceStr) || parseFloat(goods.goodsPrice) > parseFloat(goods.marketPriceStr)) {
          this.$message.error("活动商品价格,不能大于商品原价");
          return;
        }
      }
      // 优惠券
      if (activity.activityDtl.sponsorRewardType === 1 && this.checkCouponList.length <= 0) {
        this.$message.error("请选择优惠券");
        return;
      }
      if (activity.activityDtl.failRewardType === 1 && this.compensationCouponList.length <= 0) {
        this.$message.error("请选择优惠券");
        return;
      }
      // 图片
      if (!this.shareImageUrl) {
        this.$message.error("请选择分享图片");
        return;
      }
      if (!this.topImageUrl) {
        this.$message.error("请选择顶部宣传图");
        return;
      }
      // 处理券参数
      const checkCouponRegCode = [];
      this.checkCouponList.forEach((coup) => {
        checkCouponRegCode.push(coup.regCode);
      });
      const compensationCouponRegCode = [];
      this.compensationCouponList.forEach((coup) => {
        compensationCouponRegCode.push(coup.regCode);
      });
      // 处理商品参数
      const activityGoodsList = [];
      this.checkGoodsList.forEach((goods) => {
        activityGoodsList.push(goods);
      });

      activity.startTime = activity.date[0]; //eslint-disable-line
      activity.endTime = activity.date[1]; //eslint-disable-line
      activity.activityGoodsList = activityGoodsList;
      // 活动规则
      const activityDtl = Object.assign({}, activity.activityDtl);
      activityDtl.shareImage = this.shareImageUrl;
      activityDtl.coverImage = this.topImageUrl;
      activityDtl.description = this.$refs.tinymce.getMain();
      activityDtl.failRewardRule = JSON.stringify(compensationCouponRegCode);
      activityDtl.successRewardRule = JSON.stringify(checkCouponRegCode);
      // 设置值
      activity.activityDtl = activityDtl;
      console.info(activityDtl);
      this.$store.dispatch("group/groupActivity/insertOrUpdate", this.activity).then((res) => {
        if (res.code === "0") {
          this.$message.success("添加成功");
          this.toGroupList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    detail() {
      this.$store.dispatch("group/groupActivity/detail", this.activityId).then((data) => {
        if (!data.data) {
          return;
        }
        const activity = data.data;
        activity.date = [activity.startTimeStr,activity.endTimeStr]; //eslint-disable-line
        // 商品
        const { activityGoodsList } = activity;
        if (activityGoodsList) {
          activityGoodsList.forEach((goods) => {
            if (goods.goodsEntity) {
              goods.name = goods.goodsEntity.name;
              goods.spec = goods.goodsEntity.spec;
              goods.marketPriceStr = goods.goodsEntity.marketPriceStr;
              goods.picUrl = goods.goodsEntity.picUrl;
            }
            if (!goods.volumeLimit || goods.volumeLimit === 0) {
              goods.volumeLimit = "";
            }
          });
        }
        this.checkGoodsList = activityGoodsList;
        // 优惠券
        const { activityDtl } = activity;
        const checkCouponList = [];
        const compensationCouponList = [];
        if (this.shopCouponList) {
          this.shopCouponList.forEach((coupon) => {
            coupon.isCheck = false;
            if (activityDtl.successRewardRule.indexOf(coupon.regCode) !== -1) {
              coupon.isCheck = true;
              checkCouponList.push(coupon);
            }
            if (activityDtl.failRewardRule.indexOf(coupon.regCode) !== -1) {
              coupon.isCheck = true;
              compensationCouponList.push(coupon);
            }
          });
        }
        this.checkCouponList = checkCouponList;
        this.compensationCouponList = compensationCouponList;
        // 图片
        let shareImageUrl = "";
        let topImageUrl = "";
        if (activityDtl.shareImage) {
          shareImageUrl = activityDtl.shareImage;
        }
        if (activityDtl.coverImage) {
          topImageUrl = activityDtl.coverImage;
        }
        if (shareImageUrl) {
          this.shareImageUrl = shareImageUrl;
        }
        if (topImageUrl) {
          this.topImageUrl = topImageUrl;
        }
        this.TinymceMain = activityDtl.description;
        this.$refs.tinymce.setMain(activityDtl.description);
        this.activity = activity;
      });
    },
    toGroupList() {
      this.$router.push("/mj/groupList");
    },
  },
};
</script>

<style lang="scss" scoped>
body {
  margin: 0;
}
@import "index";
</style>
